type ShouldFilterNsfwCharactersParameters = {
  isNsfwCharacterDiscoveryAllowed: boolean;
  isNsfwEnabled: boolean;
  isNsfwToggleAllowed: boolean;
  isNsfwToggled: boolean;
  isShowNsfwEnabled: boolean;
};

const resolveShouldFilterNsfwCharacters = ({
  isNsfwCharacterDiscoveryAllowed,
  isNsfwEnabled,
  isNsfwToggleAllowed,
  isNsfwToggled,
  isShowNsfwEnabled,
}: ShouldFilterNsfwCharactersParameters): boolean => {
  return !isNsfwCharacterDiscoveryAllowed || !isNsfwEnabled || (isNsfwToggleAllowed && (!isShowNsfwEnabled || !isNsfwToggled));
};

export default resolveShouldFilterNsfwCharacters;
